import { Text } from '@chakra-ui/react';

import { formatHelpers } from '@nocowanie/core';

import { ForeignPriceProps } from './foreign-price.props';

export const ForeignPrice = ({
    price,
    currency,
    convertedPrice,
    convertedCurrency,
    children,
    ...rest
}: ForeignPriceProps): JSX.Element => {
    const withConvertedPrice = !!(
        ((price > 0 && convertedPrice && convertedPrice > 0) ||
            (price === 0 && convertedPrice !== undefined)) &&
        convertedCurrency &&
        convertedCurrency !== currency
    );

    return (
        <Text as={'strong'} textAlign={'right'} {...rest}>
            {formatHelpers.price(price, currency)}
            {withConvertedPrice ? (
                <Text as="span" fontWeight="normal" fontSize={'0.875em'}>
                    {' '}
                    (∼{formatHelpers.price(convertedPrice, convertedCurrency)})
                </Text>
            ) : null}
        </Text>
    );
};
